<script lang="ts" setup>
import { CriteriaInstance } from "types/Checklist";
import { EvaluationCriteria } from "types/EvaluationResults";

const props = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
});
const documentId = inject("documentId") as any;

const documentChecklistStore = useDocumentChecklistStore(documentId);
const { mechanicsCriteria, mechanicsAnnotations } = storeToRefs(
  documentChecklistStore
);

const documentAnnotaitonStore = useDocumentAnnotationsStore(documentId);
const { allAnnotations } = storeToRefs(documentAnnotaitonStore);

const nuxtApp = useNuxtApp();

const annotationComment = computed(() => {
  return (annotationId: string) => {
    var annotation = allAnnotations.value.find(
      (annotation) => annotation.id == annotationId
    );

    if (!annotation) return "";

    // @ts-ignore
    return nuxtApp.$convertQuillDeltaToPlaintext(annotation.commentObject);
  };
});

const documentHighlightStore = useDocumentHighlightStore(documentId);

const onMouseOverCriteria = (criteria: EvaluationCriteria) => {
  const tokenPositions = criteria.relevantInstances
    .map((relevantInstance) => {
      // flatten the relevant instance tokens
      return relevantInstance.tokens
        .map((token) => {
          const tokenId = token.id;
          const tokenGlobalPosition =
            useDocumentTokenIdPositionMapStore(
              documentId
            ).tokenGlobalPositionFromId(tokenId);
          return tokenGlobalPosition;
        })
        .flat();
    })
    .flat();

  documentHighlightStore.setTokenPositionsToHighlight(tokenPositions);
};

const onMouseOver = (annotationId: string) => {
  useDocumentAnnotationHighlight().highlightAnnotation(annotationId);
};

const onMouseOut = () => {
  useDocumentAnnotationHighlight().clearAnnotationsToHighlight();
  documentHighlightStore.clearSelectedHighlight();
};
</script>

<template>
  <div class="flex flex-col">
    <BaseDelayedMouseover
      v-for="criteria of mechanicsCriteria"
      :key="criteria.instanceUid"
      class="flex flex-row justify-between items-center py-[4px] pl-2 min-h-[40px] hover:bg-opacity-10 hover:bg-medium-default cursor-pointer"
      @mouseover="onMouseOverCriteria(criteria)"
      @mouseout="onMouseOut()"
    >
      <span class="mx-2 text-body-1 font-bold select-none">
        {{ criteria.config.text }}
      </span>
      <span class="text-body-1 mr-2 w-[50px] text-right shrink-0">
        {{ criteriaInstance.pointsPerInstance }}
        {{ criteriaInstance.pointsPerInstance > 1 ? "pts" : "pt" }}
      </span>
    </BaseDelayedMouseover>
    <BaseDelayedMouseover
      v-for="annotationId of mechanicsAnnotations"
      :key="annotationId"
      class="flex flex-row justify-between items-center py-[4px] pl-2 min-h-[40px] hover:bg-opacity-10 hover:bg-medium-default cursor-pointer"
      @mouseover="onMouseOver(annotationId as string)"
      @mouseout="onMouseOut()"
    >
      <span class="mx-2 text-body-1 font-bold select-none">
        {{ annotationComment(annotationId as string).trim() }}
      </span>
      <span class="text-body-1 mr-2 w-[50px] text-right shrink-0">
        {{ criteriaInstance.pointsPerInstance }}
        {{ criteriaInstance.pointsPerInstance > 1 ? "pts" : "pt" }}
      </span>
    </BaseDelayedMouseover>
  </div>
</template>

<style scoped></style>
